import { TimezoneSelect } from '@entities/schedules';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Settings from '@mui/icons-material/Settings';

import {
	Column,
	SessionBlock,
	Week,
	WeekDate,
	useAddressLoader,
	useDateSwitch,
	useWeek,
} from '@features/shedules';

import { ArrowIosLeft, ArrowIosRight } from '@shared/assets';
import { IconButton, LargeHeader, Nav, TextButton } from '@shared/ui';

import { ModalLarge } from 'library/components/common';

import * as st from './styles.module.scss';

export const ModalSchedules: React.FC = () => {
	const navigate = useNavigate();
	const { code, clientId, tabCode } = useParams<{ [x: string]: string }>();

	const { date, reset, add, subtract } = useDateSwitch('week');
	const { sessions } = useWeek(date);
	useAddressLoader();

	const assignConsultation = (id: number) =>
		navigate(`/clients/${code}/${clientId}/${tabCode}/assign/${id}`);

	const openConsultation = (id: number) =>
		navigate(`/clients/${code}/${clientId}/${tabCode}/assign/consultation/${id}`);

	const openEditor = () => navigate(`/schedule/schedules/editor`);

	const onClose = () => navigate(`/clients/${code}?onClose=reload`);

	return (
		<ModalLarge isOpen disableHeader onRequestClose={onClose}>
			<LargeHeader title="Записать на консультацию" onClose={onClose} />
			<div className={st.wrap}>
				<section className={st.schedule__toolbar}>
					<Nav>
						<div></div>
						<div>
							<WeekDate date={date} />
						</div>
						<div>
							<TimezoneSelect />
							<TextButton onClick={reset} variant="dark" size="small">
								Сегодня
							</TextButton>
							<IconButton onClick={subtract} variant="dark">
								<ArrowIosLeft />
							</IconButton>
							<IconButton onClick={add} variant="dark">
								<ArrowIosRight />
							</IconButton>
							<IconButton onClick={openEditor} variant="dark">
								<Settings />
							</IconButton>
						</div>
					</Nav>
				</section>

				<Week date={date}>
					{sessions.map((day) => (
						<Column key={day[0].start.toDateString()}>
							{day.map((session) => (
								<SessionBlock
									key={session.start.toLocaleTimeString()}
									start={session.start}
									end={session.end}
									onAvailableClick={assignConsultation}
									onScheduleClick={openConsultation}
								/>
							))}
						</Column>
					))}
				</Week>
			</div>
		</ModalLarge>
	);
};
